import { usePrevious } from "@offstreetparking/design-system/hooks";
import { useEffect, useRef } from "react";
import { useFlowOverlayContainment } from "../../../../host/overlay-containment";
import { stepIds, usePermitActiveStep } from "../../PermitContextProvider";

export const useScrollToActiveStep = () => {
	const sectionRef = useRef<HTMLElement>(null);
	const stepContentRef = useRef<HTMLDivElement>(null);
	const activeStepId = usePermitActiveStep();
	const prevStepId = usePrevious(activeStepId);
	const contained = useFlowOverlayContainment();

	useEffect(() => {
		if (prevStepId === activeStepId) {
			return;
		}
		if (activeStepId === stepIds.confirmation) {
			if (!contained) {
				window.scrollTo({ top: 0, behavior: "smooth" });
			}
			return;
		}
		const section = sectionRef.current;
		if (!section) {
			return;
		}
		const isFirstLoad = prevStepId === undefined;
		const scrollsToActiveStep = !contained && window.matchMedia("(max-width: 1279px)").matches;
		if (scrollsToActiveStep) {
			const lastCompletedSummaryItem = Array.from(
				document.querySelectorAll<HTMLElement>("[data-summary-item]"),
			).at(-1);
			const scrollTarget = lastCompletedSummaryItem ?? (isFirstLoad ? undefined : section);
			scrollTarget?.scrollIntoView({ behavior: "smooth", block: "start" });
		}
		if (isFirstLoad) {
			return;
		}
		const firstFocusable =
			stepContentRef.current?.querySelector<HTMLElement>(
				'input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled)',
			) ?? stepContentRef.current?.querySelector<HTMLElement>('button, [href], [tabindex]:not([tabindex="-1"])');
		firstFocusable?.focus({
			preventScroll: scrollsToActiveStep || window.matchMedia("(pointer: coarse)").matches,
		});
	}, [activeStepId, prevStepId, contained]);

	return { sectionRef, stepContentRef };
};
